import { sbEditable, SbEditableBlok } from '@storyblok/storyblok-editable'
import * as React from 'react'
import styled from 'styled-components'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { containerDefault } from '../../lib/styles/Container'
import { typoParagraphIntro } from '../../lib/styles/Typography'
import { ButtonBlok } from '../../types'
import { ButtonModule } from '../Button'

export interface HeroTitleBlok extends SbEditableBlok {
  preline?: string
  headline: string
  subline?: string
  buttons?: ButtonBlok[]
  marginBlock?: string
  headlineSize: 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'normal' | 'small'
  alignment: 'left' | 'center'
  headlineSyntax: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  gap?: string
  descriptionColor?: string
}

export interface HeroTitleProps {
  blok: HeroTitleBlok
}

const Wrapper = styled.div<{
  alignment: 'left' | 'center'
  marginBlock?: string
  gap?: string
}>`
  ${containerDefault}
  display: flex;
  flex-direction: column;
  margin-block: ${({ marginBlock }) => marginBlock || '0rem'};
  margin-inline: auto;
  text-align: ${({ alignment }) => alignment};
  gap: ${({ gap }) => gap || '0.5rem'};
`

const Subline = styled.div<{ $alignment: 'left' | 'center'; $largeMargin?: boolean }>`
  ${typoParagraphIntro}
  margin-inline: ${p => (p.$alignment === 'left' ? '0' : 'auto')};
  max-width: 36rem;
`

const Buttons = styled.div<{ $alignment: 'left' | 'center'; $largeMargin?: boolean }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: ${({ $alignment }) => ($alignment === 'left' ? 'flex-start' : 'center')};
  margin-top: ${p => (p.$largeMargin ? '3rem' : '2.5rem')};
`

export const HeroTitle = ({ blok }: HeroTitleProps) => {
  return (
    <Wrapper alignment={blok.alignment || 'center'} marginBlock={blok?.marginBlock} {...sbEditable(blok)} gap={blok?.gap}>
      <TitleWithPrefix
        prefix={blok.preline}
        title={blok.headline}
        headlineSize={blok.headlineSize}
        headlineType={blok.headlineSyntax}
        textAlign={blok.alignment}
        descriptionColor={blok.descriptionColor}
      />
      {blok.subline && (
        <Subline $largeMargin={blok.headlineSize === 'xlarge'} $alignment={blok.alignment}>
          {blok.subline}
        </Subline>
      )}
      {blok.buttons && blok.buttons.length > 0 && (
        <Buttons $alignment={blok.alignment} $largeMargin={blok.headlineSize === 'xlarge'}>
          {blok.buttons.map((button, i) => (
            <ButtonModule key={i} blok={button} />
          ))}
        </Buttons>
      )}
    </Wrapper>
  )
}
